export function numberFormat(num: number | string): string {
    if (typeof num === 'string') {
        num = parseInt(num, 10);
    }

    Math.round(num * 100) / 100;

    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
